export enum UserStatus {
    ACTIVE = "active",
    INACTIVE = "inactive",
}

export enum UserRole {
    ADMIN = "Admin",
    USER = "User",
    TRAINER = "Trainer",
    SUPER_ADMIN = "Super_Admin",
    VERIFIED_PARTNER = "Verified_Partner"
}

export enum UserGender {
    MALE = "male",
    FEMALE = "female",
    OTHER = "other",
}
